import type { FeatureDefinitionNext, FeatureDependencyNext } from './types';

export const sortFeatures = (features: FeatureDefinitionNext[]): FeatureDefinitionNext[] => {
  const sortedFeatures: FeatureDefinitionNext[] = [];
  const visitedImplementations: Record<string, boolean> = {};
  const isFeatureVisited = (feature: FeatureDefinitionNext) => sortedFeatures.some(({ name }) => name === feature.name);
  const findFeature = (dependency: FeatureDependencyNext) => features.find(({ role }) => role === dependency.name);
  const visitFeature = (feature: FeatureDefinitionNext, featureAncestors: string[] = []) => {
    if (isFeatureVisited(feature)) {
      return;
    }

    if (feature.implements && feature.role) {
      featureAncestors.push(feature.role);
      visitedImplementations[feature.role] = true;
    }

    feature.dependsOn.forEach((dependency) => {
      if (featureAncestors.indexOf(dependency.name) !== -1) {
        throw new Error(
          `[bootstrapper] Detected cyclic dependencies for feature '${feature.name}' during initialization: ${dependency.name}`
        );
      }

      if (visitedImplementations.hasOwnProperty(dependency.name)) {
        return;
      }

      const dependentFeature = findFeature(dependency);

      if (!dependentFeature) {
        if (dependency.required) {
          throw new Error(
            `[bootstrapper] Dependencies requirements for feature '${feature.name}' not fulfilled: '${dependency.name}' is missing`
          );
        }

        return;
      }

      visitFeature(dependentFeature, featureAncestors.slice(0));
    });

    sortedFeatures.push(feature);
  };

  for (const feature of features) {
    visitFeature(feature);
  }

  return sortedFeatures;
};
